export default __webpack_public_path__ + "static/media/B_Besouro.68608c4a.svg";